/**
 * <grid-density> - PLP gitter-taethedsvaelger, KUN mobil (< 834px).
 * Flipper data-density ('2'|'1') paa den naermeste <collection-filters>-vaert,
 * saa produktgitteret skifter mellem 2-up og 1-up (ren CSS). Desktop er laast
 * 4-up og tablet 3-up (ejerbeslutning 2026-09-28; var 4/5 paa desktop).
 * Vaerten swappes ALDRIG af Section Rendering, saa taetheden overlever
 * filter/sort/paginate-genrender. Valget gemmes i localStorage
 * ('kca:grid-density-mobile'; ny noegle, saa gamle 4/5-vaerdier ignoreres).
 *
 * Progressive enhancement: uden JS staar gitteret 2-up; knappen er skjult
 * indtil komponenten er :defined (CSS i main-collection).
 */
const STORAGE_KEY = 'kca:grid-density-mobile';

class GridDensity extends HTMLElement {
  connectedCallback() {
    this.host = this.closest('collection-filters');
    this.button = this.querySelector('[data-density-toggle]');
    if (!this.host || !this.button) return;

    let stored = null;
    try {
      stored = localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      /* private mode: ingen persistering */
    }
    if (stored === '1' || stored === '2') {
      this.#apply(stored);
    } else {
      this.#reflect();
    }

    this.button.addEventListener('click', () => {
      const next = this.host.getAttribute('data-density') === '1' ? '2' : '1';
      try {
        localStorage.setItem(STORAGE_KEY, next);
      } catch (e) {
        /* private mode: valget gaelder kun denne visning */
      }
      this.#apply(next);
    });
  }

  #apply(density) {
    this.host.setAttribute('data-density', density);
    this.#reflect();
  }

  // aria-pressed = 1-up aktiv (label'en: "Ét produkt pr. raekke").
  #reflect() {
    const single = this.host.getAttribute('data-density') === '1';
    this.button.setAttribute('aria-pressed', single ? 'true' : 'false');
  }
}

if (!customElements.get('grid-density')) {
  customElements.define('grid-density', GridDensity);
}
